import React, { useState } from "react";
import ContainerEventsQuery from "../Components/ContainerEventsQuery";
import ImgProfileNature from "../medias/Bike Trail Sport copier.jpg";
import Select from "react-select";
import Regions from "../Data/ListRegions";
import distanceNature from "../Data/DistanceNature";
import triNature from "../medias/1920-waikoloa-usa-2011-Goran Bogicevic.JPG";
import LandscapeOutlinedIcon from "@material-ui/icons/LandscapeOutlined";

export const Nature = () => {
  const [region, setSelectedRegion] = useState({
    value: "Ile-de-France",
    label: "Ile-de-France",
  });
  const handleRegion = (region) => {
    setSelectedRegion(region);
  };

  return (
    <section>
      {/* header */}
      <div className="container mt-5">
        <div className="pt-3 visible-sm"></div>
        <h1 className="text-warning">
          Cross-triathlon : natation en eau libre, VTT et trail dans la nature
        </h1>
        <br />
        <div className="row mb-md-5">
          <div className="col-md-2">
            <img
              src={ImgProfileNature}
              alt="Profil débutant"
              className="d-block mx-auto w-100 mb-3"
            />
            <h2 style={{ fontSize: "1rem", fontWeight: "bold" }}>
              On the rock.
            </h2>
          </div>
          <div className="col-md-6 mb-3 pr-5">
            Vous avez du mal à envisager le triathlon en milieu urbain&nbsp;? Le
            cross-triathlon est fait pour vous&nbsp;! Avec l'offre du calendrier
            national des triathlons en pleine nature, vous pourrez expérimenter,
            seul ou à plusieurs, des épreuves souvent plus courtes que la longue
            distance. Mais non exemptes de sensations, à la campagne, en forêt,
            dans des chemins de terre voire les cailloux... Pour cela, prévoyez
            un vélo tout-terrain et selon le parcours à pied, des chaussures
            adaptées.
          </div>
          {/* header right part */}
          <div className="col-md-4 px-1 sticky-top"></div>
        </div>
      </div>
      {/* page left part*/}
      <div className="row my-2">
        <div className="col-md-8">
          <div className="row mb-4">
            <div className="col-md-4">
              <h5 className="text-warning">
                Des chemins de terre et des parcours variés
              </h5>
              <p>
                Souvent plus physiques, car ils ne sont pas sur route, les
                cross-triathlons sont également plus courts. Différentes
                distances existent, comme pour le triathlon sur route,
                permettant à chacun de débuter ou de s'affronter. De nombreuses
                épreuves sont proposées avec des parcours aux profils très
                différents. Tant en charme qu'en niveau d'exigence.
              </p>
            </div>
            <div className="col-md-8">
              <h3 className="font-weight-bold">
                Quel <span className="text-primary">cross-triathlon</span>{" "}
                choisir&nbsp;?
              </h3>
              <div>
                <h6>Choisir votre région</h6>

                <Select
                  defaultValue="Ile-de-France"
                  onChange={handleRegion}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  options={Regions}
                  value={region}
                  placeholder="Votre région"
                  className="col-md-6 pl-0"
                />
              </div>
              <ContainerEventsQuery
                region={region.value}
                remove={false}
                format={["M", "L", "XL", "XXL"]}
                relay={""}
                Elevation_bike={0}
                Elevation_run={0}
                bibs={25000}
                Swimenv={[
                  "Piscine",
                  "Lac",
                  "Mer",
                  "Rivière",
                  "Plan d'eau",
                  "0",
                ]}
                crosstri={["1"]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <h5 className="text-warning">
                Performer sur un cross-triathlon exigeant
              </h5>
              <p>
                Courir en pleine nature est définitivement une autre discipline
                où le terrain (boue, chemin, côtes, forêts...) constitue des
                paramètres à bien prendre en compte. Le dénivelé est un critère
                de difficulté supplémentaire, rendant ces épreuves plus
                sélectives. Car gérer des "coups de cul" sur des terrains
                compliqués est vraiment technique. Où la nature du sol nécessite
                de bien manier son VTT et de monter des bosses à pied.
              </p>
            </div>
            <div className="col-md-8">
              <h3 className="font-weight-bold">
                <LandscapeOutlinedIcon className="mr-2" />
                Des cross-triathlon
                <span className="text-primary">
                  {" "}
                  avec un minimum de dénivelé (300 m D+)
                </span>
              </h3>
              <img src={triNature} alt="photo de triathlon Goran Bogicevic" />
              <ContainerEventsQuery
                region={region.value}
                remove={false}
                format={["M", "L", "XL", "XXL"]}
                relay={""}
                Elevation_bike={300}
                Elevation_run={100}
                bibs={25000}
                Swimenv={[
                  "Piscine",
                  "Lac",
                  "Mer",
                  "Rivière",
                  "Plan d'eau",
                  "0",
                ]}
                crosstri={["1"]}
              />
            </div>
          </div>
        </div>
        {/* page right part*/}
        <div className="col-md-4">
          <div className="container">
            <div className="row">
              <p className="font-weight-bold mb-1">
                Cross-triathlon&nbsp;: des distances adaptées
              </p>
              <div>
                {distanceNature.map((item) => (
                  <div className="row border-bottom">
                    <div className="col-3 font-weight-bold">{item.value}</div>
                    <div className="col-3">{item.swim}</div>
                    <div className="col-3">{item.bike}</div>
                    <div className="col-3">{item.run}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
